'use client';
import fork from '@haaretz/l-fork.macro';
import TextField from '@haaretz/s-text-field';
import nameValidator from '@haaretz/s-validators/nameValidator';
import passwordValidator from '@haaretz/s-validators/passwordValidator';
import React from 'react';
import s9 from 'style9';

import type { TextFieldProps } from '@haaretz/s-text-field';

export type FieldNames = 'password' | 'firstName' | 'lastName';
type State = 'default' | 'invalid' | 'empty';

const labelTexts: Record<FieldNames, string> = {
  password: fork({ default: 'סיסמה', hdc: 'Password' }),
  firstName: fork({ default: 'שם פרטי', hdc: 'First Name' }),
  lastName: fork({ default: 'שם משפחה', hdc: 'Last Name' }),
};

// `c` is short for `classNames`
const c = s9.create({
  field: {
    height: 'max-content',
    width: '100%',
  },
});

export default function RequiredField({
  styleExtend = [],
  onInput,
  textFieldType,
  ...props
}: TextFieldProps & { textFieldType: FieldNames }) {
  const [state, setState] = React.useState<State>('default');
  const textFieldRef = React.useRef<HTMLInputElement | null>(null);

  const value = textFieldRef.current?.value || '';

  const description =
    textFieldType === 'password' ? passwordValidator(value) : nameValidator(value, textFieldType);

  return (
    <TextField
      type="text"
      {...props}
      description={description}
      isInvalid={state !== 'default'}
      label={labelTexts[textFieldType]}
      required
      onInput={event => {
        if (state !== 'default') {
          setState('default');
        }

        if (typeof onInput === 'function') {
          onInput(event);
        }
      }}
      styleExtend={[c.field, ...styleExtend]}
      onInvalid={e => {
        e.preventDefault();

        setState(e.currentTarget.value ? 'invalid' : 'empty');
      }}
      ref={textFieldRef}
    />
  );
}
